import React, { Fragment } from 'react';
import * as PropTypes from 'prop-types';
import get from 'lodash/get';

import { PROFILE_FIELDS_TYPES } from '../../../../constants/formFields';
import TextInput from '../../../TextInput';
import ErrorBlock from '../../../common/ErrorBlock';
import SelectCustom from '../../../SelectCustom';
import {
  FIELD_FILLING_TYPES,
  getFieldProps,
} from '../../../../utils/fields/getFieldProps';

const {
  ROOM,
  SERVICE,
  LOCATION,
  PROVIDER,
  REASON_TYPE,
  REASON_NOTE,
  REASON_COMMENT,
  PAYMENT_STATUS,
  REASON_TYPE_ID,
} = PROFILE_FIELDS_TYPES;

export const VisitInfoForm = ({
  errors,
  formatMessage,
  onChange,
  locationsList,
  servicesList,
  reasonList,
  paymentStatusList,
  searchProvider,
  providersList,
  isLoadingProviders,
  locationId,
  serviceId,
  reasonTypeId,
  note,
  providerId,
  room,
  paymentStatus,
}) => {
  const makeField = getFieldProps(formatMessage, onChange);
  return (
    <Fragment>
      <SelectCustom
        {...makeField(LOCATION, FIELD_FILLING_TYPES.REQUIRED)}
        options={locationsList}
        value={locationId}
        needUpdateDefaultValue
      />
      <SelectCustom
        {...makeField(SERVICE, FIELD_FILLING_TYPES.REQUIRED)}
        options={servicesList}
        value={serviceId}
        needUpdateDefaultValue
        disabled={!locationId}
      />
      <SelectCustom
        {...makeField(REASON_TYPE, FIELD_FILLING_TYPES.REQUIRED)}
        options={reasonList}
        value={reasonTypeId}
        needUpdateDefaultValue
        disabled={!serviceId}
        name={REASON_TYPE_ID}
        onChange={({ value }) => onChange({ [REASON_TYPE_ID]: value })}
      />
      <TextInput
        {...makeField(REASON_NOTE, FIELD_FILLING_TYPES.OPTIONAL)}
        value={note}
        name={REASON_COMMENT}
        onChange={value => onChange({ [REASON_COMMENT]: value })}
      />
      <SelectCustom
        {...makeField(PROVIDER, FIELD_FILLING_TYPES.OPTIONAL)}
        onInputChange={searchProvider}
        options={providersList}
        value={providerId}
        canSearch
        isLoading={isLoadingProviders}
      />
      <TextInput
        {...makeField(ROOM, FIELD_FILLING_TYPES.OPTIONAL)}
        value={room}
      />
      <SelectCustom
        {...makeField(PAYMENT_STATUS, FIELD_FILLING_TYPES.OPTIONAL)}
        options={paymentStatusList}
        value={paymentStatus}
        needUpdateDefaultValue
      />
      <If condition={Boolean(errors)}>
        <ErrorBlock errors={get(errors, 'description')} className="mt3" />
      </If>
    </Fragment>
  );
};

VisitInfoForm.propTypes = {
  errors: PropTypes.oneOfType([
    PropTypes.bool,
    PropTypes.shape({ description: PropTypes.string }),
  ]),
  formatMessage: PropTypes.func,
  onChange: PropTypes.func,
  locationId: PropTypes.number,
  serviceId: PropTypes.number,
  reasonTypeId: PropTypes.number,
  note: PropTypes.string,
  providerId: PropTypes.number,
  room: PropTypes.string,
  paymentStatus: PropTypes.string,
  locationsList: PropTypes.array,
  servicesList: PropTypes.array,
  reasonList: PropTypes.array,
  paymentStatusList: PropTypes.array,
  searchProvider: PropTypes.func,
  providersList: PropTypes.array,
  isLoadingProviders: PropTypes.bool,
};



// WEBPACK FOOTER //
// ./src/components/DashboardRecord/DashboardVisitInfo/VisitInfoForm/index.jsx